import { render } from "./property-neighborhood.vue?vue&type=template&id=482aa5a4"
import script from "./property-neighborhood.js?vue&type=script&lang=js"
export * from "./property-neighborhood.js?vue&type=script&lang=js"

import "./property-neighborhood.vue?vue&type=style&index=0&id=482aa5a4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__